import { render, staticRenderFns } from "./ScopeMasterDetailView.vue?vue&type=template&id=cf09fbfa"
import script from "./ScopeMasterDetailView.vue?vue&type=script&lang=js"
export * from "./ScopeMasterDetailView.vue?vue&type=script&lang=js"
import style0 from "./ScopeMasterDetailView.vue?vue&type=style&index=0&id=cf09fbfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports